export const CreditOfferedStatus = {
  ACTIVE: 'active',
  PENDING_PAYMENT: 'pending_payment',
  SOLD: 'sold',
};
